import validator from "validator";
import { jwtDecode as jwt_decode } from "jwt-decode";
import { BASEURL } from "../CONSTANTS";
import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Spinner,
  Card,
  Col,
  Container,
  Form,
  Row,
  CardBody,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import LinkSignUp from "./LinkSignUp";
import { Loader } from "./Loader";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";
import { useScreenSize, useCustomScreen } from "../../src/Components/Utils";
import ReCAPTCHA from "react-google-recaptcha";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Login = () => {
  const navigate = useNavigate();
  const [callApiToggle, setCallApiToggle] = useState(false);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [isEmailValid, setIsEMailValid] = useState(false);
  const [invalidUser, setInvalidUser] = useState(false);
  const [password, setPassword] = useState("");
  const [invalidMsg, setInvalidMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [invalidLogin, setInvalidLogin] = useState(false);
  const {
    isAuthenticated,
    setIsAuthenticated,
    login,
    logout,
    authToken,
    decodedToken,
  } = useAuth();
  const [notACustomer, setNotACustomer] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  
  const onEmailHandle = (e) => {
    const email = e.target.value;
    setEmail(e.target.value);
    if (validator.isEmail(email)) {
      setIsEMailValid(true);
    } else {
      setIsEMailValid(false);
    }
  };
  const onPasswordHandle = (e) => {
    const password = e.target.value;
    setPassword(e.target.value);
  };
  // useEffect(()=>{
  //     loginHandler();
  // },[])
  const loginHandler = async () => {
    if (email !== "" && password !== "") {
      const data = {
        username: email,
        password: password,
      };
      try {
        setLoading(!loading);
        const result = await fetch(`${BASEURL}auth/login`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (result.status === 200) {
          const res = await result.json();
          const currentTime = Date.now();
          // const expirationTime = currentTime + 24 * 60 * 60 * 1000; // for 24 hours
          // const expirationTime = currentTime + 1 * 60 * 1000; // for 1 minute for testing

          localStorage.setItem("token", res["accessToken"]);
          setToken(res["accessToken"]);
          // localStorage.setItem("expirationTime", expirationTime.toString());
          const decodedToken = jwt_decode(res["accessToken"]);
          "unique_name" in decodedToken &&
            localStorage.setItem("userId", decodedToken["unique_name"]);
          "customerid" in decodedToken &&
            localStorage.setItem("customerId", decodedToken["customerid"]);

          localStorage.setItem("decode", JSON.stringify(decodedToken));

          if (decodedToken.role === "Customer") {
            setNotACustomer(false);
            setInvalidLogin(false);
            login(res["accessToken"], decodedToken);
            toast.success("Login Success", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            if (localStorage.getItem("login-from") === "Map") {
              navigate("/order/instructions");
            } else {
              navigate("/profile/billing-info");
            }
          } else {
            setNotACustomer(true);
            logout();
          }
        } else if (result.status === 401) {
          const res = await result.json();
          toast.error(res.message, {
            duration: 7000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        } else {
          toast.error("Login Failed", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          setInvalidLogin(!invalidLogin);
        }
      } catch (e) {
        console.log(e.status, "error with 401");
        // toast.error("Failed to Login, Incorrect USer Name or Password");
        setInvalidUser(true);

        setInvalidMsg(e?.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const onChange = async (value) => {
    setRecaptchaValue(value);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

   
  }, []);

  const devicePixelRatio = window.devicePixelRatio;

  return (
    <>
      {loading ? (
        <Container
          style={{ height: "100vh" }}
          className="w-100% d-flex justify-content-center align-items-center"
        >
          <Spinner animation="border" role="status"></Spinner>
        </Container>
      ) : (
        <>
       <Container
  style={{
    marginTop: (() => {
      if (isSmallScreen) return "85px";
      if (isMediumScreen) return "95px";
      return "85px";
    })(),

    marginBottom: (() => {
      

      if (isSmallScreen) return "-80px";

      if (isMediumScreen) {
        if (devicePixelRatio>= 1.5) return "-130px";
        if (devicePixelRatio >= 1.25) return "-250px";
        if (devicePixelRatio >= 1.0) return "-180px";
      }

      if (isIpadProPortrait) return "-150px";

      if (isLargeScreen) {
        if (devicePixelRatio >= 1.5) return "-180px";
        if (devicePixelRatio >= 1.25) return "-130px";
        if (devicePixelRatio>= 1.0) return "-210px";
      }

      if (isXlScreen) {
        if (devicePixelRatio >= 1.5) return "-150px";
        if (devicePixelRatio >= 1.25) return "-150px";
        if (devicePixelRatio >= 1.0) return "-150px";
      }

      if (isXxlScreen) {
        if (devicePixelRatio >= 1.5) return "-230px";
        if (devicePixelRatio>= 1.25) return "-190px";
        if (devicePixelRatio>= 1.0) return "-240px";
      }

      if (is4kScreen) return "-150px";

      return "-150px";
    })(),

    width: (() => {
      if (isSmallScreen) return "88%";
      if (isMediumScreen) return "98%";
      if (isIpadProPortrait) return "80%";
      return "69%";
    })(),

    padding: "0px 16px",
  }}
>
  <Card
    style={{
      width: "100%",
      height: isSmallScreen ? "auto" : "fit-content",
    }}
  >
    <CardBody>
      <Row
        style={{
          backgroundColor: "lightblue",
          padding: "8px",
          marginTop: "-16px",
          marginLeft: "-16px",
          marginRight: "-16px",
          fontWeight: "600",
          fontSize: (() => {
            if (isSmallScreen) return "14px";
            if (isMediumScreen) return "15px";
            if (isLargeScreen) return "16px";
            if (isXlScreen) return "17px";
            if (isXxlScreen) return "18px";
            if (is4kScreen) return "20px";
            return "16px";
          })(),
        }}
      >
        Note
      </Row>

      <Row
        style={{
          padding: "8px",
          fontSize: (() => {
            if (isSmallScreen) return "13px";
            if (isMediumScreen) return "14px";
            if (isLargeScreen) return "15px";
            if (isXlScreen) return "16px";
            if (isXxlScreen) return "17px";
            if (is4kScreen) return "18px";
            return "15px";
          })(),
          lineHeight: isSmallScreen ? "18px" : "21px",
        }}
      >
        <p>
          We have recently updated our site. If you are logging in for the first
          time after 8/2/25 then you will need to reset your password in order
          to access your account. Just click the{" "}
          <strong
            onClick={() => navigate("/forgot-password")}
            style={{ cursor: "pointer" }}
          >
            Forgot Password
          </strong>{" "}
          link below and follow the prompts.
        </p>
      </Row>
    </CardBody>
  </Card>
</Container>


          <Container
            className="gap-sm-3 d-flex justify-content-center align-items-center"
            style={{
              marginBottom: isSmallScreen
                ? "3rem"
                : is4kScreen
                ? ""
                : isXxlScreen
                ? ""
                : isXlScreen && devicePixelRatio >= 1.5
                ? "10rem"
                : isLargeScreen
                ? "5rem"
                : "",
              marginTop: isSmallScreen
                ? "6rem"
                : is4kScreen
                ? "5rem"
                : isXxlScreen
                ? ""
                : isXlScreen
                ? ""
                : isLargeScreen
                ? ""
                : "",
              // height: "80%",
              height: isSmallScreen ? "auto" : "100vh",

              // display: "flex",
              // justifyContent: "center",
              // alignItems: "center",
              // flexDirection: "column",
              // alignItems: "center",
            }}
          >
            <Row
              className="sign-up"
              style={{
                height: isSmallScreen ? "100vh" : "40vh",
                width: isSmallScreen
                  ? "90%"
                  : isIpadProPortrait
                  ? "100%"
                  : isMediumScreen
                  ? "100%"
                  : "70%",
              }}
            >
              <Col md={8} className="pb-3">
                <Card
                  style={{
                    boxShadow: "0px 9px 26px 6px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",

                    height: "100%",
                  }}
                >
                  <Card.Body
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Row style={{ width: "100%" }}>
                      <Col md={12}>
                        <p
                          style={{
                            textAlign: "center",
                            marginBottom: "1em",
                            fontSize: is4kScreen
                              ? "3rem"
                              : isXxlScreen
                              ? "1.8rem"
                              : isXlScreen
                              ? "2rem"
                              : isIpadProPortrait
                              ? "2.1rem"
                              : isLargeScreen
                              ? "2rem"
                              : isMediumScreen
                              ? "1.6rem"
                              : "1.2rem",
                          }}
                          className="login-heading"
                        >
                          Account Login
                        </p>

                        <Row className="mb-1">
                          <Col className="cust-card mb-2">
                            {/* {invalidUser && (
                              <div style={{ color: "red" }}>{invalidMsg}</div>
                            )} */}
                            <div
                              className="account-login"
                              style={{ padding: "0px " }}
                            >
                              {/* Email Input Field */}
                              <div className="mb-3 row d-flex justify-content-center align-items-center">
                                <label
                                  className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isXxlScreen
                                      ? "1.25rem"
                                      : isXlScreen
                                      ? "1.05rem"
                                      : isIpadProPortrait
                                      ? "1.8rem"
                                      : isLargeScreen
                                      ? "1rem"
                                      : isMediumScreen
                                      ? "1.3rem"
                                      : isSmallScreen
                                      ? ""
                                      : "1rem",
                                  }}
                                >
                                  Email
                                </label>
                                <div className="col-sm-8 col-md-8 col-12">
                                  <input
                                    autoComplete="false"
                                    className="form-control"
                                    type="email"
                                    value={email}
                                    onChange={onEmailHandle}
                                  />
                                </div>
                              </div>

                              {/* Password Input Field */}
                              <div className="mb-3 row d-flex justify-content-center align-items-center">
                                <label
                                  className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isXxlScreen
                                      ? "1.25rem"
                                      : isXlScreen
                                      ? "1.05rem"
                                      : isIpadProPortrait
                                      ? "1.8rem"
                                      : isLargeScreen
                                      ? "1rem"
                                      : isMediumScreen
                                      ? "1.3rem"
                                      : isSmallScreen
                                      ? ""
                                      : "1rem",
                                  }}
                                >
                                  Password
                                </label>
                                <div className="col-sm-8 col-md-8 col-12">
                                  <input
                                    autoComplete="new-password"
                                    className="form-control"
                                    type="password"
                                    value={password}
                                    onChange={onPasswordHandle}
                                  />
                                </div>
                              </div>
                              <div>
                                <div>
                                  {notACustomer
                                    ? // <p
                                      //   className="text-danger text-center"
                                      //   style={{
                                      //     fontSize: is4kScreen
                                      //       ? "2rem"
                                      //       : isXxlScreen
                                      //       ? "1.5rem "
                                      //       : isXlScreen
                                      //       ? "1.2rem"
                                      //       : isLargeScreen
                                      //       ? "1.1rem"
                                      //       : "1rem",
                                      //   }}
                                      // >
                                      //   <b>Only customer login allowed</b>
                                      // </p>
                                      toast.error(
                                        "Only customer login allowed",
                                        {
                                          duration: 7000,
                                          icon: (
                                            <FontAwesomeIcon
                                              style={{
                                                fontSize: is4kScreen
                                                  ? "1.9rem"
                                                  : isXxlScreen
                                                  ? "1.6rem"
                                                  : isXlScreen
                                                  ? "1.5rem"
                                                  : isIpadProPortrait
                                                  ? "1.8rem"
                                                  : isLargeScreen
                                                  ? "0.9rem"
                                                  : isMediumScreen
                                                  ? "1.4rem"
                                                  : "1rem",
                                              }}
                                              icon={faCircleExclamation}
                                            />
                                          ),
                                          style: {
                                            backgroundColor: "#FFC1B4",
                                            color: "red",
                                            fontSize: is4kScreen
                                              ? "1.9rem"
                                              : isXxlScreen
                                              ? "1.15rem"
                                              : isXlScreen
                                              ? "1rem"
                                              : isIpadProPortrait
                                              ? "1.8rem"
                                              : isLargeScreen
                                              ? "1rem"
                                              : isMediumScreen
                                              ? "1.1rem"
                                              : "1rem",
                                            marginTop: is4kScreen
                                              ? "2rem"
                                              : isIpadProPortrait
                                              ? "2rem"
                                              : "",
                                          },
                                        }
                                      )
                                    : invalidLogin
                                    ? // <p
                                      //   className="text-danger text-center pt-2"
                                      //   style={{
                                      //     fontSize: is4kScreen
                                      //       ? "2rem"
                                      //       : isXxlScreen
                                      //       ? "1.25rem"
                                      //       : isXlScreen
                                      //       ? "1.05rem"
                                      //       : isIpadProPortrait
                                      //       ? "1.8rem"
                                      //       : isLargeScreen
                                      //       ? "1rem"
                                      //       : isMediumScreen
                                      //       ? "1.3rem"
                                      //       : isSmallScreen
                                      //       ? ""
                                      //       : "1rem",
                                      //   }}
                                      // >
                                      //   <b>Invalid Email or Password</b>
                                      // </p>
                                      toast.error("Invalid Email or Password", {
                                        duration: 7000,
                                        icon: (
                                          <FontAwesomeIcon
                                            style={{
                                              fontSize: is4kScreen
                                                ? "1.9rem"
                                                : isXxlScreen
                                                ? "1.6rem"
                                                : isXlScreen
                                                ? "1.5rem"
                                                : isIpadProPortrait
                                                ? "1.8rem"
                                                : isLargeScreen
                                                ? "0.9rem"
                                                : isMediumScreen
                                                ? "1.4rem"
                                                : "1rem",
                                            }}
                                            icon={faCircleExclamation}
                                          />
                                        ),
                                        style: {
                                          backgroundColor: "#FFC1B4",
                                          color: "red",
                                          fontSize: is4kScreen
                                            ? "1.9rem"
                                            : isXxlScreen
                                            ? "1.15rem"
                                            : isXlScreen
                                            ? "1rem"
                                            : isIpadProPortrait
                                            ? "1.8rem"
                                            : isLargeScreen
                                            ? "1rem"
                                            : isMediumScreen
                                            ? "1.1rem"
                                            : "1rem",
                                          marginTop: is4kScreen
                                            ? "2rem"
                                            : isIpadProPortrait
                                            ? "2rem"
                                            : "",
                                        },
                                      })
                                    : null}
                                </div>
                              </div>
                              <div
                                className="d-flex recaptcha-wrapper justify-content-center align-items-center pt-1 pb-3"
                                style={{
                                  marginLeft: isLargeScreen
                                    ? "5rem"
                                    : isXlScreen
                                    ? "5rem"
                                    : isXxlScreen
                                    ? "2rem"
                                    : isMediumScreen
                                    ? "3rem"
                                    : "",
                                }}
                              >
                                <ReCAPTCHA
                                  className="responsive-recaptcha"
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isLargeScreen
                                      ? "1.5rem"
                                      : "30px",
                                    paddingRight: isIpadProPortrait
                                      ? "3.8rem"
                                      : "",
                                  }}
                                  sitekey={siteKey}
                                  onChange={onChange}
                                ></ReCAPTCHA>
                              </div>

                              {/* Login Button */}
                              <div className="d-flex justify-content-center align-items-center">
                                <Button
                                  disabled={!recaptchaValue}
                                  className="login-btns btn mb-3"
                                  type="submit"
                                  onClick={loginHandler}
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isXxlScreen
                                      ? "1.25rem"
                                      : isXlScreen
                                      ? "1.05rem"
                                      : isIpadProPortrait
                                      ? "1.8rem"
                                      : isLargeScreen
                                      ? "1rem"
                                      : isMediumScreen
                                      ? "1.3rem"
                                      : isSmallScreen
                                      ? ""
                                      : "1rem",
                                  }}
                                >
                                  Login
                                </Button>
                              </div>

                              {/* Forgot Password Link */}
                              <div className="text-center">
                                <Link to="/forgot-password">
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      fontSize: is4kScreen
                                        ? "2rem"
                                        : isXxlScreen
                                        ? "1.25rem"
                                        : isXlScreen
                                        ? "1.05rem"
                                        : isIpadProPortrait
                                        ? "1.8rem"
                                        : isLargeScreen
                                        ? "1rem"
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : isSmallScreen
                                        ? ""
                                        : "1rem",
                                    }}
                                  >
                                    Forgot Password?
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card
                  style={{
                    boxShadow: "0px 9px 26px 6px rgba(0,0,0,0.1)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "97%",
                  }}
                >
                  <Card.Body
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Row>
                      <Col md={12}>
                        <LinkSignUp page="login" />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
};
export default Login;
